import React from 'react';

function MaintenanceInfoSlide({data, type}) {
    const startDate = type == "inspection" ? data.inspectStartDate : type == "incident" ? data.incidentStartDate : data.workStartDate;
    const endDate = type == "inspection" ? data.inspectEndDate : type == "incident" ? data.incidentEndDate : data.workEndDate;
    const codeName = type == "inspection" ? data.inspectCode?.name : type == "incident" ? data.incidentCode?.name : data.workCode?.name;
    const dateTxt = type == "inspection" ? "점검일" : type == "incident" ? "장애 요청일" : "작업 요청일";

    return (
        <div className={'flex'}>
            <div>
                <table className={"w-full thumb-table"}>
                    <tbody>
                        <tr className={"h-[25px]"}>
                            <td className="thumbnail-title">{data.title.length > 24 ? data.title.substring(0, 23) + "..." : data.title}</td>
                        </tr>
                        <tr className={"h-[22px]"}>
                            <td className="thumbnail-assetCode">{codeName}</td>
                        </tr>
                        <tr className={"h-[30px]"}>
                            <td className="thumbnail-user">[요청자]{data.requester?.name} | [검수자]{data.inspector?.name}</td>
                        </tr>
                        <tr className={"h-[25px]"}>
                            <td>
                                <span className="w-full thumb-ag text-[11px] px-[8px] py-[3px] mr-1">{dateTxt} : {startDate} ~ {endDate}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default MaintenanceInfoSlide;